// Trip and Vertical Constants for FusionCab - Backend Compatible

export const VERTICALS = {
  INTERCITY: "intercity",
  AIRPORT: "airport",
  HOURLY: "hourly",
} as const;

export const TRIP_TYPES = {
  ONEWAY: "one-way",
  ROUNDTRIP: "round-trip",
  MULTICITY: "multi-city",
  PICKUP: "pickup",
  DROPOFF: "drop-off",
  HRS4: "4hrs/40kms",
  HRS8: "8hrs/80kms",
  HRS12: "12hrs/120kms",
} as const;

// Frontend to Backend mapping for trip types
export const FRONTEND_TO_BACKEND_TRIP_TYPE = {
  "one-way": "one-way", // Outstation One-Way -> one-way
  "round-trip": "round-trip", // Outstation Round-Trip -> round-trip
  airport: "pickup", // Airport Transfers -> pickup
  hourly: "4hrs/40kms", // Hourly Rentals -> default to 4hrs/40kms
} as const;

// Duration mapping for hourly rentals
export const HOURLY_DURATION_MAPPING = {
  "4": "4hrs/40kms",
  "8": "8hrs/80kms",
  "12": "12hrs/120kms",
} as const;

// Type definitions for TypeScript
export type VerticalType = (typeof VERTICALS)[keyof typeof VERTICALS];
export type TripType = (typeof TRIP_TYPES)[keyof typeof TRIP_TYPES];
export type FrontendTripType = "one-way" | "round-trip" | "airport" | "hourly";
